<div class="px-8 py-4 h-screen overflow-y-auto pb-8">
  <div class="flex items-center justify-between mb-4">
    <h1 class="text-2xl font-bold text-gray-800">Cadastro de Módulos</h1>
  </div>

  <div
    *ngIf="message"
    class="mb-4 p-3 rounded-md border"
    [ngClass]="messageType === 'success' ? 'bg-green-50 text-green-700 border-green-200' : 'bg-red-50 text-red-700 border-red-200'"
  >
    {{ message }}
  </div>

  <div class="rounded-xl shadow-md p-8 max-w-7xl mx-auto bg-white">
    <h2 class="text-lg font-semibold text-gray-700 border-b pb-2 mb-4">
      {{ selectedModuleId ? 'Editar módulo' : 'Novo módulo' }}
    </h2>

    <form [formGroup]="moduleForm" (ngSubmit)="saveModule()" class="grid grid-cols-1 md:grid-cols-4 gap-3">
      <input type="text" formControlName="code" placeholder="Código (ex: estoque)" class="border border-gray-300 rounded-md px-3 py-2" />
      <input type="text" formControlName="name" placeholder="Nome" class="border border-gray-300 rounded-md px-3 py-2" />
      <label class="flex items-center gap-2 px-3">
        <input type="checkbox" formControlName="active" />
        Ativo
      </label>
      <div class="flex gap-2">
        <button type="submit" class="bg-[#fe6a00] px-4 py-2 rounded border-[#fe6a00] hover:bg-[#e65c00] text-white">
          {{ selectedModuleId ? 'Salvar' : 'Criar' }}
        </button>
        <button type="button" class="border border-orange-500 text-orange-600 px-4 py-2 rounded hover:bg-orange-50" (click)="cancelEdit()">Cancelar</button>
      </div>
    </form>

    <div class="mt-6">
      <h2 class="text-lg font-semibold text-gray-700 border-b pb-2 mb-4">Módulos cadastrados</h2>
      <div class="overflow-x-auto border border-gray-200 rounded-md">
        <table class="w-full text-sm">
          <thead class="bg-gray-50">
            <tr>
              <th class="text-left px-4 py-3 font-semibold text-gray-700">Código</th>
              <th class="text-left px-4 py-3 font-semibold text-gray-700">Nome</th>
              <th class="text-left px-4 py-3 font-semibold text-gray-700">Ativo</th>
              <th class="text-left px-4 py-3 font-semibold text-gray-700">Habilitado na empresa</th>
              <th class="text-left px-4 py-3 font-semibold text-gray-700">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of modules" class="border-t border-gray-200">
              <td class="px-4 py-3">{{ item.code }}</td>
              <td class="px-4 py-3">{{ item.name }}</td>
              <td class="px-4 py-3">{{ item.active ? 'Sim' : 'Não' }}</td>
              <td class="px-4 py-3">
                <input type="checkbox" [checked]="item.enabled" (change)="toggleCompanyModule(item, $any($event.target).checked)" />
              </td>
              <td class="px-4 py-3">
                <div class="flex items-center gap-3">
                  <button class="text-orange-600 hover:text-orange-700" (click)="editModule(item)">Editar</button>
                  <button class="text-red-600 hover:text-red-700" (click)="deleteModule(item)">Excluir</button>
                </div>
              </td>
            </tr>
            <tr *ngIf="!isLoading && modules.length === 0">
              <td colspan="5" class="px-4 py-6 text-center text-gray-500">Nenhum módulo cadastrado</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
